import React from 'react';
import PropTypes from 'prop-types';
import BEMHelper from '@ynap/bem-helper';

const bem = new BEMHelper('Input');

export const propTypes = {
    className: PropTypes.string,
    inputRef: PropTypes.func,
    allowWheel: PropTypes.bool,
    children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
};

// Blur input focus to stop scroll wheel inc/dec on input fields
// that have not explicitly asked for it
function handleWheel(e, allowWheel) {
    if (!allowWheel) e.target.blur();
}

function Input(props) {
    const { allowWheel, children, className, hasError, inputRef, ...rest } = props; // eslint-disable-line no-unused-vars

    // appends 'allowWheel' to className if prop is true.
    // We only need this if no children supplied.
    const inputClassName = className || allowWheel ? `${className || ''} ${allowWheel ? 'allowWheel' : ''}` : undefined;

    if (!children) {
        return (
            <input
                className={inputClassName}
                ref={inputRef}
                onWheel={(e) => {
                    handleWheel(e, allowWheel);
                }}
                {...rest}
            />
        );
    }

    return (
        <div className={bem(null, null, className)}>
            <input
                {...rest}
                className={allowWheel ? 'allowWheel' : ''}
                ref={inputRef}
                onWheel={(e) => {
                    handleWheel(e, allowWheel);
                }}
            />
            {typeof children === 'function' ? children(props) : children}
        </div>
    );
}

Input.propTypes = propTypes;

export default Input;
